export default __webpack_public_path__ + "static/media/3.64d8ef6f.jpg";